<template>
  <v-card
      @click="selectCard"
      class="alert-card pa-2 pl-3"
      :class="getAlertCardClass"
      style="display: inline-block; width:100%; height: 205px;"
  >
    <div>
      <i
          v-if="showHistory"
          @click="
            cardInfo.status == ALERT_STATUSES.UNACKNOWLEDGED
              ? $emit('acknowledge', cardInfo.id)
              : () => {}
          "
          :class="{
            'primary--text': cardInfo.status == ALERT_STATUSES.ACKNOWLEDGED,
          }"
          class="far fa-check-circle"
          style="font-size: 17px !important; position: absolute; top:9px; right:4px;"
      ></i>
    </div>
    <div style="height:45px;">
      <v-row class="mx-0" justify="space-between">
        <div style="font-size:15px;" :class="textClass">
          <i class="mr-1 fas fa-exchange-alt primary--text"></i>
          {{ cardInfo.name }}
        </div>
        <!--        <template v-if="metaData && Object.keys(metaData).length">-->
        <!--          <v-tooltip bottom content-class="meta-data-tooltip-surface">-->
        <!--            <template v-slot:activator="{ on }">-->
        <!--              <v-icon-->
        <!--                  class="meta-data-important-icon"-->
        <!--                  v-on="on"-->
        <!--                  color="blue"-->
        <!--                  size="medium"-->
        <!--                  dark-->
        <!--                  :style="{marginRight: showHistory ? '24px' : 'unset'}"-->
        <!--              >-->
        <!--                fas fa-exclamation-circle-->
        <!--              </v-icon>-->
        <!--            </template>-->
        <!--            <span>-->

        <!--              <div v-if="metaData" class="meta-data-content">-->
        <!--                <div-->
        <!--                    v-for="(value, key) in metaData"-->
        <!--                    :key="`meta-data-content-key-${key}`"-->
        <!--                    class="meta-data-item lineHeight1 mb-1"-->
        <!--                    :class="textClass"-->
        <!--                    style="font-size:12px;"-->
        <!--                >-->
        <!--                  <div class="meta-data-item-key">{{ key }}</div>-->
        <!--                  <ul>-->
        <!--                    <li-->
        <!--                        v-for="(v, k) in (showHistory ? JSON.parse(value) : value)"-->
        <!--                        :key="`meta-data-content-key-value-${key}-${k}`"-->
        <!--                        class="meta-data-item-value"-->
        <!--                    >-->
        <!--                      <span class="meta-data-content-value-key">-->
        <!--                        {{ k }}:-->
        <!--                      </span>-->
        <!--                      <span class="meta-data-content-value-property">-->
        <!--                        {{ (k === 'date') ? humanFriendlyFromISO8601(v) : v }}-->
        <!--                      </span>-->
        <!--                    </li>-->
        <!--                  </ul>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </span>-->
        <!--          </v-tooltip>-->
        <!--        </template>-->
      </v-row>
      <p class="mt-2 mb-1" style="font-size:0.75rem; color:rgb(160, 160, 0);">
        {{ cardInfo.cardDate }}
      </p>
    </div>
    <v-row class="overflowY-auto mx-0 pt-2 mb-1" style="height:70px;">
      <p
          v-if="triggered"
          style="font-size:14px;"
          class="mb-0"
          :class="textClass"
      >
        <!-- {{ cardInfo.id }} -->
        {{ showHistory ? cardInfo.message : cardInfo.lastMessage }}
      </p>
      <p v-else style="font-size:14px;" class="mb-0" :class="textClass">
        Alert has not been triggered yet.
      </p>
    </v-row>

    <v-row v-if="triggered" justify="space-between" style="height:70px;">
      <v-col cols="5" class="py-0">
        <p class="mt-2 mb-1" style="font-weight: 300;" :class="textClass">
          Source
        </p>
        <div style="max-height:40px;max-width:116px;overflow-y: auto;">
          <p
              v-for="source in sourceNames"
              :key="source"
              class="light-text lineHeight1 mb-1"
              :class="textClass"
              style="font-size:12px;"
          >
            {{ source }}
          </p>
        </div>
      </v-col>
      <v-col cols="7" style="font-size: 13px;" class="pa-0 align-self-end">
        <p
            v-if="!showHistory"
            class="lineHeight1 mb-1"
            style="color:rgb(255, 143, 0);font-size: 12px;"
        >
          {{ cardInfo.lastTriggeredHR }}
          <br/>
          Triggered:
          {{ cardInfo.totalAlerts }}
        </p>
        <p
            v-else
            class="lineHeight1 mb-1"
            style="color:rgb(255, 143, 0);font-size: 12px;"
        >
          {{ cardInfo.createdOnHR }}
        </p>
      </v-col>
    </v-row>

    <!--    <v-menu-->
    <!--        v-if="triggered && Object.keys(cardInfo.parameters).length"-->
    <!--        transition="scroll-x-transition"-->
    <!--        left-->
    <!--        offset-y-->
    <!--        :close-on-content-click="false"-->
    <!--        min-width="280"-->
    <!--        open-on-hover-->
    <!--        disabled-->
    <!--    >-->
    <!--      <template v-slot:activator="{ on }">-->
    <!--        <v-btn-->
    <!--            v-on="on"-->
    <!--            disabled-->
    <!--            class="alert-cation small-button-force"-->
    <!--            style="position:absolute;right:12px;bottom:8px;background-color:grey !important;border-color: grey !important;"-->
    <!--            x-small-->
    <!--            fab-->
    <!--            @click="-->
    <!--              infoTabs = null;-->
    <!--              currentTabItem = 0;-->
    <!--            "-->
    <!--        >-->
    <!--          <i-->
    <!--              class="fas fa-info white&#45;&#45;text"-->
    <!--              style="font-size: 14px !important;margin-left:1px;"-->
    <!--          ></i>-->
    <!--        </v-btn>-->
    <!--      </template>-->
    <!-- <v-runtime-template-shell :template="template" :parameters="cardInfo.parameters" /> -->
    <!-- <v-card
    class="accent"
    style="border-radius: 8px;border:1px solid rgb(255, 255, 255, 0.2);"
  >
    <v-card-title
      style="background: #47BD96;font-size: 1rem;"
      class="py-0"
      >{{ cardInfo.name }}</v-card-title
    >
    <v-tabs
      v-model="infoTabs"
      centered
      hide-slider
      :background-color="$vuetify.theme.dark ? '#262B2E' : '#edeef2'"
    >
      <v-tab
        v-for="source in sourceNames"
        :key="source"
        class="px-2"
        style="font-size:14px;"
        >{{ source }}</v-tab
      >
    </v-tabs>

    <v-tabs-items class="mb-2 mt-1" :touchless="true" v-model="infoTabs">
      <v-tab-item
        v-for="info in cardInfo.info"
        :key="info.login"
        class="accent"
      >
        <v-row class="mx-2">
          <v-col cols="6" class="pa-1">
            <p class="mb-0 ml-2" style="font-size:14px;">Source :</p>
          </v-col>
          <v-col cols="6" class="pa-1" style="font-size:14px;">{{
            info.sourceName
          }}</v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="6" class="pa-1">
            <p class="mb-0 ml-2" style="font-size:14px;">Login :</p>
          </v-col>
          <v-col cols="6" class="pa-1" style="font-size:14px;">{{
            info.login
          }}</v-col>
        </v-row>
        <v-row class="mx-2">
          <v-col cols="6" class="pa-1">
            <p class="mb-0 ml-2" style="font-size:14px;">Profit :</p>
          </v-col>
          <v-col cols="6" class="pa-1" style="font-size:14px;"
            >${{ info.profit }}</v-col
          >
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card> -->
    <!--    </v-menu>-->

    <v-speed-dial
        v-if="showHistory"
        style="position: absolute !important; bottom:8px !important;right:8px !important;"
        right
        bottom
        direction="left"
        :open-on-hover="!isNotDesktop"
    >
      <!-- :value="cardInfo.showActions" -->
      <template v-slot:activator>
        <v-btn class="small-button-force" x-small fab color="primary">
          <i
              class="fas fa-chevron-left"
              style="color:white;font-size:15px;"
          ></i>
        </v-btn>
      </template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
              @click="cardInfo.status != ALERT_STATUSES.ACKNOWLEDGED ? $emit('acknowledge', cardInfo.id) : 0"
              v-on="on"
              class="alert-cation mr-1 small-button-force"
              :class="{
                'disabled-alert-cation':
                  cardInfo.status == ALERT_STATUSES.ACKNOWLEDGED,
              }"
              icon
          >
            <i
                class="far fa-check-circle"
                style="color:white;font-size: 17px !important;"
            ></i>
          </v-btn>
        </template>
        <span>Confirm</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
              v-on="on"
              class="alert-cation disabled-alert-cation mr-1 small-button-force"
              icon
          >
            <!-- style="background-color:#FFB300 !important;border-color:#FFB300 !important;" -->
            <i
                class="fas fa-user-minus ml-1"
                style="color:white;font-size: 13px !important;"
            ></i>
          </v-btn>
        </template>
        <span>Exclude Account</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
              v-on="on"
              class="alert-cation disabled-alert-cation small-button-force"
              icon
          >
            <!-- style="background-color:#E53935 !important;border-color:#D32F2F !important;" -->
            <i
                class="fas fa-ban"
                style="color:white;font-size: 17px !important;"
            ></i>
          </v-btn>
        </template>
        <span>Block Trading</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
              @click="deleteHistoryCard"
              v-on="on"
              class="alert-cation red mr-1 small-button-force"
              :class="{
                'disabled-alert-cation':
                  cardInfo.status == ALERT_STATUSES.ACKNOWLEDGED,
              }"
              icon
          >
            <i
                class="fas fa-trash"
                style="color:white;font-size: 13px !important;"
            ></i>
          </v-btn>
        </template>
        <span>Delete</span>
      </v-tooltip>


    </v-speed-dial>

    <i
        v-show="!showHistory"
        class="fas fa-history alert-card-history-icon"
    ></i>
  </v-card>
</template>

<script>
import {ALERT_STATUSES} from "../utilities/enums";
import {humanFriendlyFromISO8601} from "@/utilities/formatters";
// import VRuntimeTemplateShell from "./VRuntimeTemplateShell";
export default {
  name: "AlertCard",
  props: {
    cardInfo: {
      type: Object,
      default: () => {
      },
    },
    sourceNames: {
      type: Array,
      default: () => {
      },
    },
    cardIndex: {
      type: Number,
      default: 0,
    },
    showHistory: {
      type: Boolean,
      default: false,
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    infoTabsProp: {
      type: Number,
      default: null,
    },
    // metaData: {
    //   type: Object,
    //   default: null,
    // }
  },
  data: () => ({
    ALERT_STATUSES: ALERT_STATUSES,
    template: `
    <v-card class="accent">
      <v-card-title class="primary">
        High frequency trades
      </v-card-title>
      <div class="pa-3">
        <p>Login: {{ parameters.login }}</p>
        <p>Source: {{ parameters.source_id }}</p>
        <p class="mb-0">Total Trades: {{ parameters.totaltrades }}</p>
      </div>
    </v-card>
    `,
    showMetaData: false,
  }),
  // components: {
  //   VRuntimeTemplateShell
  // },
  methods: {
    humanFriendlyFromISO8601,
    deleteHistoryCard() {
      this.$emit("delete-history-card")
    },
    selectCard() {
      if (!this.showHistory && this.triggered)
        this.$emit("card-selected", {
          id: this.cardInfo.alertCardId,
          name: this.cardInfo.name,
        });
    },
    getCountSum(info) {
      let sum = 0;
      info.forEach((el) => (sum = sum + el.count));
      return sum;
    },
  },
  computed: {
    textClass() {
      let cssClass;
      if (this.$vuetify.theme.dark) {
        cssClass = !this.showHistory
            ? this.cardInfo.enabled
                ? "white--text"
                : "grey--text"
            : "supplementary-class";
        return this.$vuetify.theme.dark
            ? cssClass
            : cssClass + " text--darken-2";
      } else {
        cssClass = !this.showHistory
            ? this.cardInfo.enabled
                ? "black--text"
                : "grey--text"
            : "supplementary-class";
        return this.$vuetify.theme.dark
            ? cssClass
            : cssClass + " text--darken-2";
      }
    },
    getAlertCardClass() {
      return !this.showHistory
          ? this.cardInfo.enabled
              ? "supplementary-class"
              : "alert-disabled"
          : "supplementary-class";
    },
    triggered() {
      return this.showHistory ? true : this.cardInfo.lastMessage != "N/A";
    },
    infoTabs: {
      get() {
        return this.infoTabsProp;
      },
      set(v) {
        this.$emit("update:infoTabs", v);
      },
    },
  },
};
</script>

<style scoped src="../css/utilities/scoped/alertCard.css"></style>
<style src="../css/utilities/alertCard.css"></style>
